/**
 * @fileoverview Auto Scroll Controller Module.
 * Manages the auto-scrolling feature for a dynamic index section on the page.
 * This includes handling scroll behaviors, setting up titles and anchors, and controlling next/previous buttons.
 */
import { elementExists } from "../Utils";

const OutlineScrollController = {
    dynamicIndexSelector: '.dynamic-index-js',
    nextButtonSelector: '.dynamic-index-next-js',
    prevButtonSelector: '.dynamic-index-prev-js',
    outlineSelector: '.outline-js',
    outlineAnchorSelector: '.outline-index-anchor-js',

    /**
     * Initializes the OutlineScrollController.
     * Sets up titles, anchors, and scroll event listeners if the dynamic index element exists.
     */
    init() {
        if (elementExists(this.outlineSelector)) {
            this.setAnchors();
            setTimeout(this.initObserverOutline(), 1000);
        } else {
            if (!elementExists(this.dynamicIndexSelector)) return;
            setTimeout(this.initObserverAction(), 1000);
        }
    },

    initObserverAction() {
        const options = {
            threshold: [0.3],
        };

        const dynamicIndex = document.querySelector(this.dynamicIndexSelector);
        const nextButton = document.querySelector(this.nextButtonSelector);
        const prevButton = document.querySelector(this.prevButtonSelector);

        const dynamicIndexWidth = dynamicIndex.scrollWidth - 10;

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry => {
                if (entry.intersectionRatio >= 0.42) {
                    setCurrent(entry.target);
                }
            }));
        }, options);

        const setCurrent = (section) => {
            document.querySelectorAll('.current').forEach((el) => {
                el.classList.remove('current');
            });
            section.classList.add('current');
            let selector = document.querySelector(`#navListDynamic a[href="#${section.id}"]`);
            if (selector != null) {

                dynamicIndex.scrollTo({
                    left: selector.offsetLeft,
                    top: 0,
                    behavior: 'smooth'
                });

                if (selector.offsetLeft + dynamicIndex.clientWidth >= dynamicIndexWidth) {
                    nextButton.classList.add('disabled');
                }

                if (selector.offsetLeft <= 0) {
                    prevButton.classList.add('disabled');
                }
                selector.classList.add('current');
            }
        };
        const sections = document.querySelectorAll('h2');
        sections.forEach((section) => observer.observe(section));
    },

    initObserverOutline() {
        // An object with options for the IntersectionObserver.
        const options = {
            // 0.5 = The callback is fired when 50% of the element is visible
            // We can add more values to the array, like 0.25, 0.75 or 1.0
            threshold: [1]
        };

        // Instantiate the IntersectionObserver class
        const observer = new IntersectionObserver((entries, observer) => {
            // This is the callback.
            entries.forEach((entry => {
                // Checks if 50% or more of the element is visible in the viewport
                if (entry.intersectionRatio >= 0.5) {
                    // Call the setCurrent function and pass the element (DOM-node)
                    setCurrent(entry.target);
                }
            }));
            // End of callback. Pass the options object as the second argument.
        }, options);

        const setCurrent = (section) => {
            // Finds all elements (<a> and <section>) with the .current class and remove it.
            document.querySelectorAll('.current').forEach((el) => {
                el.classList.remove('current');
            });

            // Add the .current class to the current <section>...
            section.classList.add('current');
            // ...and the current <a> in the navbar.
            let selector = document.querySelector(`#navListOutline a[href="#${section.id}"]`);
            if (selector != null) {
                selector.classList.add('current');
            }
        };

        // Query the DOM for all the sections...
        const sections = document.querySelectorAll('h2');
        // Loop through them and tell our instance of the 
        // IntersectionObserver class to observe each one of them.
        sections.forEach((section) => observer.observe(section));
    },

    setAnchors() {
        document.querySelectorAll(this.outlineAnchorSelector).forEach(anchor => {
            anchor.addEventListener('click', e => {
                e.preventDefault();
                const targetId = anchor.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 100;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            });
        });
    },
};

export default OutlineScrollController;